import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const scrollToHash = (hash) => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });

// Shared navigation for routes ("/about") and home anchors ("/#csr").
export const useSiteNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const navTo = useCallback(
    (href) => {
      const isRoute = href.startsWith('/') && !href.includes('#');
      if (isRoute && pathname === href) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if (isRoute) {
        navigate(href);
        setTimeout(() => window.scrollTo({ top: 0 }), 60);
        return;
      }
      const hash = href.startsWith('/#') ? href.slice(1) : href;
      if (pathname === '/') {
        scrollToHash(hash);
        return;
      }
      navigate('/');
      setTimeout(() => scrollToHash(hash), 420);
    },
    [pathname, navigate]
  );

  return { navTo, pathname };
};
